/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Upgrade_ActionInputs */

const en_directory_promotion_upgrade_action = /** @type {(inputs: Directory_Promotion_Upgrade_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Sponsor pricing`)
};

const zh_directory_promotion_upgrade_action = /** @type {(inputs: Directory_Promotion_Upgrade_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看 Sponsor 价格`)
};

/**
* | output |
* | --- |
* | "View Sponsor pricing" |
*
* @param {Directory_Promotion_Upgrade_ActionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_upgrade_action = /** @type {((inputs?: Directory_Promotion_Upgrade_ActionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Upgrade_ActionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_upgrade_action(inputs)
	return zh_directory_promotion_upgrade_action(inputs)
});
export { directory_promotion_upgrade_action as "directory.promotion.upgrade_action" }